function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.26308 9.85226C0.850272 9.13401 1.09656 8.21483 1.81319 7.79921L12.5964 1.54529C13.313 1.12967 14.2286 1.375 14.6414 2.09325L17.7543 7.5095C18.1672 8.22775 17.9209 9.14693 17.2042 9.56255L6.42105 15.8165C5.70443 16.2321 4.78884 15.9868 4.37603 15.2685L1.26308 9.85226Z",
  stroke: "white",
  strokeWidth: 1.125
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.52732 11.7459C8.30239 11.2964 8.56624 10.3022 8.1203 9.5263C7.67437 8.7504 6.68534 8.48285 5.91026 8.93237C5.13519 9.38188 4.87134 10.3761 5.31728 11.152C5.76322 11.9279 6.75225 12.1954 7.52732 11.7459Z",
  stroke: "white",
  strokeWidth: 1.125
});

function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.9d20a2f0.svg";
export { ForwardRef as ReactComponent };